import axios from 'axios';

const API_BASE_URL = `${global.config.apiDomain}/game/treasure/web`;

const headers = {
  "Content-Type": "application/json"
};

// Validation functions
const validateTreasureData = (treasure) => {
  if (!treasure.id || !treasure.name || !treasure.imageUrl || !treasure.animatedUrl || !treasure.closeImageUrl) {
    throw new Error('Thiếu thông tin bắt buộc: id, name, imageUrl, animatedUrl, closeImageUrl');
  }
  
  if (treasure.buyPrice <= 0) {
    throw new Error('Giá mua phải lớn hơn 0');
  }
  
  if (!treasure.gifts || treasure.gifts.length === 0) {
    throw new Error('Rương phải có ít nhất 1 món quà');
  }
  
  // Validate gifts
  treasure.gifts.forEach((gift, index) => {
    if (!gift.id || !gift.name) {
      throw new Error(`Quà thứ ${index + 1} thiếu thông tin bắt buộc`);
    }
    
    if (!gift.kind || !['normal', 'rare'].includes(gift.kind)) {
      throw new Error(`Quà thứ ${index + 1} có loại không hợp lệ. Chỉ cho phép: normal, rare`);
    }
    
    if (gift.dropRate <= 0 || gift.dropRate > 100) {
      throw new Error(`Quà thứ ${index + 1} có tỷ lệ trúng không hợp lệ (1-100%)`);
    }
    
    if (gift.buyPrice === undefined || gift.buyPrice < 0) {
      throw new Error(`Quà thứ ${index + 1} có giá mua không hợp lệ (phải >= 0)`);
    }
  });
  
  // Validate total drop rate = 100%
  const totalDropRate = treasure.gifts.reduce((sum, gift) => sum + (gift.dropRate || 0), 0);
  if (totalDropRate !== 100) {
    throw new Error('Tổng tỷ lệ trúng các món quà phải là 100%');
  }
  
  // Validate time
  if (treasure.startTime >= treasure.endTime) {
    throw new Error('Thời gian bắt đầu phải sớm hơn thời gian kết thúc');
  }
  
  // Validate notiAppTime
  if (treasure.notiAppTime !== undefined && (treasure.notiAppTime < 0)) {
    throw new Error('Thời gian hiện noti toàn app phải từ 0 giây');
  }
};

const handleResponse = (response) => {
  if (!response.data) {
    throw new Error('No data received from server');
  }
  return response.data;
};

const handleError = (error) => {
  const message = error.response?.data?.message || error.message || 'An error occurred';
  throw new Error(message);
};

export const  TreasureService = {
  getTreasureList: async () => {
    try {
      const response = await axios.post(
        `${API_BASE_URL}/list`,
        {},
        { headers }
      );
      return handleResponse(response);
    } catch (error) {
      return handleError(error);
    }
  },

  createTreasure: async (treasure) => {
    try {
      // Validate data before sending
      validateTreasureData(treasure);
      
      const response = await axios.post(
        `${API_BASE_URL}/create`,
        treasure,
        { headers }
      );
      return handleResponse(response);
    } catch (error) {
      return handleError(error);
    }
  },

  updateTreasure: async (treasure) => {
    try {
      // Validate data before sending
      validateTreasureData(treasure);
      
      const response = await axios.post(
        `${API_BASE_URL}/update`,
        treasure,
        { headers }
      );
      return handleResponse(response);
    } catch (error) {
      return handleError(error);
    }
  },

  deleteTreasure: async (treasureId) => {
    try {
      if (!treasureId) {
        throw new Error('Treasure ID is required');
      }
      const response = await axios.post(
        `${API_BASE_URL}/delete`,
        { id: treasureId },
        { headers }
      );
      return handleResponse(response);
    } catch (error) {
      return handleError(error);
    }
  },

  searchGift: async (searchGift) => {
    try {
      if (!searchGift) {
        throw new Error('Treasure ID is required');
      }
      const response = await axios.post(
        `${API_BASE_URL}/search-gift`,
        { id: searchGift },
        { headers }
      );
      return handleResponse(response);
    } catch (error) {
      return handleError(error);
    }
  },


  // Lấy danh sách cài đặt mưa quà
  getRainSettings: async () => {
    try {
      const response = await axios.post(
        `${API_BASE_URL}/rain-setting`,
        { headers }
      );
      return handleResponse(response);
    } catch (error) {
      return handleError(error);
    }
  },

  // Lưu hoặc cập nhật thông tin cài đặt mưa quà (bao gồm timeRanges)
  updateRainSettings: async (settingsData) => {
    try {
      const response = await axios.post(
        `${API_BASE_URL}/update-rain-setting`,
        settingsData,
        { headers }
      );
      return handleResponse(response);
    } catch (error) {
      return handleError(error);
    }
  },

  createRainSettings: async (settingsData) => {
    try {
      const response = await axios.post(
        `${API_BASE_URL}/create-rain-setting`,
        settingsData,
        { headers }
      );
      return handleResponse(response);
    } catch (error) {
      return handleError(error);
    }
  },

}; 